export default __webpack_public_path__ + "static/media/museum.d8c8eaf4.jpg";